import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as FileSaver from "file-saver";
import { EnumManagerReportNotes } from "../../../../shared/enums/enumManagerReportNotes";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { DialogModule } from "primeng/dialog";
import { ManagerReportNotesComponent } from "../manager-report-notes/manager-report-notes.component";
import { Q3ReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3ReportLocationWiseBcReportDto";

@Component({
  selector: "jni-location-wise-q3-grid1",
  templateUrl: "./location-wise-q3-grid1.component.html",
  styleUrls: ["./location-wise-q3-grid1.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    DialogModule,
    ManagerReportNotesComponent,
  ],
})
export class LocationWiseQ3Grid1Component {
  @Input() grid1: Q3ReportLocationWiseBcReportDto[] = [];
  @Input() location = "";
  @Input() manager = "";
  @Input() isSuperManager = false;
  @Input() isAdmin = false;
  @Input() currentQuarter = "";
  @Output() submitEvent = new EventEmitter<{
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }>();
  fileName = "dashboard";
  bc = "";
  notes = "";

  bcPersonnelNumber = "";

  managerNotesModal = false;

  bacReportEnum = EnumManagerReportNotes[EnumManagerReportNotes.BacReport];

  exportExcelFile() {
    const object = this.grid1.map(datum => {
      return {
        ["BC"]: datum.bc,
        ["BAC/BAS"]: datum.cordinatorAndSupport,
        ["Current Assigned Support"]: datum.currentSupport,
        ["Current YTD GP%"]: datum.currentYtdGp,
        ["Running 12-month GP"]: datum.runningTwelveMonthGp,
        ["Support % Based Off Numbers"]: datum.supportBasedOffNumbers,
        ["GP Backlog"]: datum.gpBacklog,
        ["Support Difference"]: datum.supportDifference,
        ["Notes"]: datum.notes,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(
        excelBuffer,
        `${this.location} - ${this.currentQuarter} Report`
      );
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onNotesClick(data: Q3ReportLocationWiseBcReportDto) {
    if (this.isSuperManager || this.isAdmin) {
      this.managerNotesModal = true;
      this.bc = data.bc;
      this.notes = data.notes;
      this.bcPersonnelNumber = data.bcPersonnelNumber;
    }
  }

  onCancel() {
    this.managerNotesModal = false;
  }

  onSubmit(data: {
    manager: string;
    bcPersonnelNumber: string;
    notes: string;
    type: string;
  }) {
    this.managerNotesModal = false;
    this.submitEvent.emit(data);
  }
}
